/**
 * Copy options config for Duplicate Facility modal.
 * Single source of truth for "what will be copied" labels and prop keys.
 */

export const COPY_OPTIONS = [
  { key: 'hasCleaningStandards', label: 'Cleaning Standards' },
  { key: 'hasSoilLoadLevels', label: 'Soil Load Levels' },
  { key: 'hasWaterChanges', label: 'Water Changes' },
];

export const DEFAULT_DUPLICATE_NAME_SUFFIX = ' (Copy)';
